import { useCallback, useReducer } from 'react';

const factoryReducer = (createEmptySpeaker) => {
  const reducer = (state, action) => {
    if (action.type === '_add') {
      const newItem = createEmptySpeaker();
      return {
        ...state,
        [newItem.id]: newItem,
      };
    } else if (action.type === '_delete') {
      const newState = { ...state };
      delete newState[action.id];
      return newState;
    } else {
      return {
        ...state,
        [action.id]: {
          ...state[action.id],
          [action.type]: action.value,
        },
      };
    }
  };

  return reducer;
};

const getInitialState = (hasDefaultValue, createEmptyItem, previousList) => {
  if (previousList) {
    return previousList;
  }

  if (hasDefaultValue) {
    const newItem = createEmptyItem();
    return {
      [newItem.id]: newItem,
    };
  }

  return {};
};

const useFormList = (createEmptyItem, hasDefaultValue, previousList) => {
  const [state, dispatch] = useReducer(
    factoryReducer(createEmptyItem),
    getInitialState(hasDefaultValue, createEmptyItem, previousList)
  );

  const add = useCallback(() => {
    dispatch({ type: '_add' });
  }, []);

  const remove = useCallback((id) => {
    dispatch({ type: '_delete', id });
  }, []);

  const update = useCallback(({ id, type, value }) => {
    dispatch({ type: type, id, value });
  }, []);

  return {
    list: state,
    add,
    remove,
    update,
  };
};

export default useFormList;
